export default __webpack_public_path__ + "static/media/3t.7c5be71c.jpg";